import { graphql } from '@apollo/client/react/hoc';

import UserProfileShowPageQuery from 'buyside/graphql/queries/UserProfileShowPage';
import UpdateUserProfileBackgroundImageMutation from 'buyside/graphql/mutations/UpdateUserProfileBackgroundImage';
import CreateMessageMutation from 'buyside/graphql/mutations/CreateMessage';
import UpdateUserProfileMutation from 'buyside/graphql/mutations/UpdateUserProfile';

import UserProfileShowPage from 'buyside/components/presentation/UserProfileShowPage/userProfileShowPage';

import { flowRight as compose } from 'buyside/util/lodashAlt';

const withData = graphql(UserProfileShowPageQuery, {
  props({ data: { loading, currentUser, userProfile } }) {
    return {
      loading,
      currentUser,
      userProfile
    };
  },
  options: ({ profileId }) => ({ variables: { profileId } })
});

const withUpdateBackgroundImage = graphql(UpdateUserProfileBackgroundImageMutation, {
  props: ({ mutate, ownProps: { profileId } }) => ({
    updateBackgroundImage: ({ cropData, imageData, removeImage }) => {
      return mutate({
        variables: {
          profileId,
          imageData,
          cropData: JSON.stringify(cropData),
          removeImage: removeImage
        }
      });
    }
  })
});

const withCreateMessage = graphql(CreateMessageMutation, {
  props: ({ mutate }) => ({
    createMessage: ({ body, subject, receiverUserId }) => {
      return mutate({
        variables: {
          body,
          subject,
          receiverUserId
        }
      });
    }
  })
});

const withUpdateUserProfile = graphql(UpdateUserProfileMutation, {
  props: ({ mutate }) => ({
    updateUserProfile: ({ userProfile, section }) => {
      const {
        city,
        summary,
        imageData,
        cropData,
        removeImage,
        employerHistories,
        sectorExpertise,
        geographicExpertise,
        assetClassExpertise,
        schoolHistories,
        hometown,
        investmentHero,
        favoriteInvestmentBook,
        investingStyle,
        languagesSpoken,
        certifications,
        resume,
        workPhone,
        profileTestResults,
        profileAttachments,
        profileAnswers
      } = userProfile;
      return mutate({
        variables: {
          profileId: userProfile.id,
          section,
          city,
          summary,
          imageData,
          cropData,
          removeImage,
          employerHistories: JSON.stringify(employerHistories),
          sectorExpertise,
          geographicExpertise,
          assetClassExpertise,
          schoolHistories: JSON.stringify(schoolHistories),
          hometown,
          investmentHero,
          favoriteInvestmentBook,
          investingStyle,
          languagesSpoken,
          certifications,
          resume: JSON.stringify(resume),
          workPhone,
          profileTestResults: JSON.stringify(profileTestResults),
          profileAttachments: JSON.stringify(profileAttachments),
          profileAnswers: JSON.stringify(profileAnswers)
        }
      });
    }
  })
});

const UserProfileShowPageContainer = compose(
  withData,
  withUpdateBackgroundImage,
  withCreateMessage,
  withUpdateUserProfile
)(UserProfileShowPage);

export default UserProfileShowPageContainer;
